// El layout raiz apaga el SSR (la app es una SPA), asi que el prerender de
// cualquier ruta genera un shell vacio y el contenido lo pinta el navegador.
// Para esta pagina eso no sirve: Google Play revisa la URL de la politica de
// privacidad desde afuera, y si la lee sin ejecutar JavaScript veria una pagina
// en blanco. Aca reactivamos el SSR solo para esta ruta, asi el HTML servido
// trae el texto completo.
export const ssr = true;
export const prerender = true;
